import script from "./AccountVerificationActions.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountVerificationActions.vue?vue&type=script&setup=true&lang=js"

import "./AccountVerificationActions.vue?vue&type=style&index=0&id=49913ba0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49913ba0"]])

export default __exports__